module.exports = __webpack_public_path__ + "static/media/copyright-hover.b37bdc7b.png";